// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step-3-container .search-form .input-container {
  position: sticky;
  top: 0px;
}
.step-3-container .search-form .questions-container {
  overflow: auto;
  height: 550px;
}
.step-3-container .form-container-wrapper {
  height: 400px;
  overflow: auto;
}
.step-3-container .cta-list svg {
  width: 20px;
  height: 20px;
  fill: #101010;
}
.step-3-container .delete-confirmation-modal .modal-content {
  display: none;
}
.step-3-container .delete-confirmation-modal .modal-container {
  height: -moz-fit-content;
  height: fit-content;
}
.step-3-container .delete-confirmation-modal .modal-footer {
  margin-top: 2rem;
}
.step-3-container .delete-confirmation-modal .modal-footer .primary-cta {
  background: #D92D20;
}`, "",{"version":3,"sources":["webpack://./src/routes/event-create/containers/step-3/style.scss"],"names":[],"mappings":"AAEI;EACE,gBAAA;EACA,QAAA;AADN;AAII;EACE,cAAA;EACA,aAAA;AAFN;AAME;EACE,aAAA;EACA,cAAA;AAJJ;AAQI;EACE,WAAA;EACA,YAAA;EACA,aAAA;AANN;AAWI;EACE,aAAA;AATN;AAYI;EACE,wBAAA;EAAA,mBAAA;AAVN;AAaM;EAAA;AAAA;AAEA;EACE,mBAAA;AAVR","sourcesContent":[".step-3-container {\n  .search-form {\n    .input-container {\n      position: sticky;\n      top: 0px;\n    }\n  \n    .questions-container {\n      overflow: auto;\n      height: 550px;\n    }\n  }\n\n  .form-container-wrapper {\n    height: 400px;\n    overflow: auto;\n  }\n\n  .cta-list {\n    svg {\n      width: 20px;\n      height: 20px;\n      fill: theme('colors.black');\n    }\n  }\n\n  .delete-confirmation-modal {\n    .modal-content {\n      display: none;\n    }\n\n    .modal-container {\n      height: fit-content;\n    }\n    .modal-footer {\n      @apply mt-8;\n\n      .primary-cta {\n        background: theme('colors.error');\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
